module.exports = __webpack_public_path__ + "static/img/bg.2eaa9e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/about/img/bg.jpg
// module id = VOY8
// module chunks = 1